/* src/app/notification-settings/location-settings-grid/notification-type-header/notification-type-header.component.scss */
:host.status-header .notification-type-header {
  padding: 0;
  padding-left: 28px;
}
.notification-type-header {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 28px;
  white-space: nowrap;
  font-weight: normal;
}
.notification-type-header > label {
  padding-top: 8px;
}
.notification-type-header > on-off-tri-toggle {
  padding: 11px 0;
}
.notification-type-header > div {
  padding-bottom: 8px;
}
/*# sourceMappingURL=notification-type-header.component.css.map */
